import { DialogMessageViewModel } from '@common/model/dialog/message/dialogMessageViewModel';
import { useDeliveries } from './useDeliveries';

export const useIsRead = (message: DialogMessageViewModel): boolean => {
  const deliveries = useDeliveries(message);
  return deliveries.findIndex((delivery) => delivery.isRead) !== -1;
};
